import {
  type IncomingMessage,
  ListenerEvent,
  MessageHandler
} from '@carvana/merch-native';
import { useContext, useMemo } from 'react';
import ErrorContext from '~/context/common/ErrorContext';
import { logError } from '~/utilities/loggers';

type ErrorMessagePayload = { errorMessage: string };

function isErrorMessage<ListenerEventType>(
  message: IncomingMessage<ListenerEventType, any>
): message is IncomingMessage<ListenerEventType, ErrorMessagePayload> {
  return (
    message.event === ListenerEvent.Error &&
    message.payload.errorMessage != null
  );
}

export default function useErrorHandler<ListenerEvent>(): MessageHandler<
  ListenerEvent,
  ErrorMessagePayload
> {
  const { setNativeError } = useContext(ErrorContext);

  return useMemo(
    () =>
      new MessageHandler(isErrorMessage, message => {
        const { errorMessage, ...context } = message.payload;
        const err = new Error(errorMessage);

        setNativeError(err);
        logError(err, { location: 'Native', ...context });
      }),
    [setNativeError]
  );
}
